import { FC } from 'react';
import { isFeatureEnabled } from '../../../../config';
import LoginContainerNew from './LoginContainerNew';
import LoginContainerOld from './LoginContainerOld';
import { ILoginContainerProps } from './types';

// TODO: Remove this once new brand login is fully rolled out
const LoginContainer: FC<ILoginContainerProps> = isFeatureEnabled('NewBrandLogin')
    ? LoginContainerNew
    : LoginContainerOld;

export default LoginContainer;
